import React from 'react'
import './Footer2.css'

var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
var currentScrollPos = window.pageYOffset;
  if (prevScrollpos < currentScrollPos) {
    document.getElementById("footer").style.bottom = "-76px";
  } else {
    document.getElementById("footer").style.bottom = "0";
  }
  prevScrollpos = currentScrollPos;
}

function Footer2() {
    return (
        <div className="footer2" id="footer">
        <div className="footer2Wrapper">
            
            <div className="footer2Main">
                <p>Copyright&nbsp;</p>
                <p>|</p>
                <p>&nbsp; All rights reserved 2021 &nbsp;</p>
                <p>|</p>
                <a href="/">&nbsp; Privacy</a>
            </div>

            <div className="footer2Links">
                <p>Work with us</p>
                <p>Let's Talk</p>
            </div>
            
        </div>
        </div>
    )
}

export default Footer2
